<template>
  <div>
    <button @click="show = true" class="btn-choose">选择</button>

    <div class="picker-mask" v-if="show" @click.self="show = false">
      <div class="picker-panel">
        <select v-model="selected.provinceCode" @change="onProvinceChange">
          <option v-for="(name, code) in provinces" :key="code" :value="code">
            {{ name }}
          </option>
        </select>

        <select v-model="selected.cityCode" @change="onCityChange">
          <option v-for="(name, code) in cities" :key="code" :value="code">
            {{ name }}
          </option>
        </select>

        <select v-model="selected.countyCode">
          <option v-for="(name, code) in counties" :key="code" :value="code">
            {{ name }}
          </option>
        </select>

        <div class="btn-group">
          <button @click="confirm">确定</button>
          <button @click="show = false">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data'

export default {
  name: 'VantAreaPickerNative',
  data() {
    return {
      show: false,
      areaList,
      selected: {
        provinceCode: '',
        cityCode: '',
        countyCode: ''
      }
    }
  },
  computed: {
    provinces() {
      return this.areaList.province_list
    },
    cities() {
      const codeStart = this.selected.provinceCode.slice(0, 2)
      const cityList = {}
      for (let code in this.areaList.city_list) {
        if (code.startsWith(codeStart)) {
          cityList[code] = this.areaList.city_list[code]
        }
      }
      return cityList
    },
    counties() {
      const codeStart = this.selected.cityCode.slice(0, 4)
      const countyList = {}
      for (let code in this.areaList.county_list) {
        if (code.startsWith(codeStart)) {
          countyList[code] = this.areaList.county_list[code]
        }
      }
      return countyList
    },
    selectedText() {
      const { provinceCode, cityCode, countyCode } = this.selected
      return `${this.areaList.province_list[provinceCode] || ''} ${this.areaList.city_list[cityCode] || ''} ${this.areaList.county_list[countyCode] || ''}`
    }
  },
  mounted() {
    // 默认选中第一个省
    const firstProvinceCode = Object.keys(this.areaList.province_list)[0]
    this.selected.provinceCode = firstProvinceCode
    this.onProvinceChange()
  },
  methods: {
    onProvinceChange() {
      const firstCity = Object.keys(this.cities)[0]
      this.selected.cityCode = firstCity
      this.onCityChange()
    },
    onCityChange() {
      const firstCounty = Object.keys(this.counties)[0]
      this.selected.countyCode = firstCounty
    },
    confirm() {
      const { provinceCode, cityCode, countyCode } = this.selected
      const result = {
        province: this.areaList.province_list[provinceCode] || '',
        city: this.areaList.city_list[cityCode] || '',
        county: this.areaList.county_list[countyCode] || '',
      }
      this.$emit('confirm', result)
      this.show = false
    }
  }
}
</script>

<style scoped>
.btn-choose {
  width: 100px;
  color: #6c6689;
  background-color: #bfbad9;
  border: none;
  height: 44px;
  line-height: 44px;
  border-radius: 6px;
  font-size: 24px;
  font-weight: bold;
  box-sizing: border-box;
}
.picker-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  /* transform: rotate(90deg); */
  /* transform-origin: left top; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.picker-panel {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  width: 400px;
}

select {
  width: 100%;
  margin-bottom: 12px;
  font-size: 24px;
  padding: 6px;
}

.btn-group {
  display: flex;
  justify-content: space-between;
}

.btn-group button {
  flex: 1;
  margin: 4px;
  padding: 8px;
  cursor: pointer;
  color: #6c6689;
  background-color: #c0bad8;
  border: none;
  outline: none;
  border-radius: 6px;
  font-weight: bold;
  font-size: 24px;
}
</style>


// WEBPACK FOOTER //
// src/pages/ares/anniversary/components/address.vue